import React, {useState} from 'react';
import dayjs from "dayjs";
import { Box, Stack, Popper, Paper, Typography } from "@mui/material";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { StaticDatePicker } from "@mui/x-date-pickers/StaticDatePicker";
import { DigitalClock, PickersDay } from "@mui/x-date-pickers";
import isSameOrAfter from 'dayjs/plugin/isSameOrAfter'
import isSameOrBefore from 'dayjs/plugin/isSameOrBefore'
import { getTicketId } from '../../util/index';
dayjs.extend(isSameOrAfter);

const OccupancyDetails = ({occupancyData, occupiedDate, isHovered, products}) => {
    const book  = occupancyData[isHovered.format("DD-MM-YYYY")]
    const prevBook = occupancyData[occupiedDate.format("DD-MM-YYYY")]
    const data = book || prevBook
    
    const itemsArr = data.items.map(item => {       
        console.log(products, data.items) 
        const prd  = products.find(prod => prod.id === item.product)
        if (prd){
            return `${prd.name} (${item.sku})`
        }
        return "";
    })
    console.log(itemsArr)
    return (
            isHovered && (
                <Box>
                    <Typography><strong>{data.tenant.name} </strong>has booked <strong>{itemsArr.join(",")} </strong> from <strong>{dayjs(data.from).format("DD-MM-YYYY HH:mm A")}</strong> to <strong> {dayjs(data.to).format("DD-MM-YYYY HH:mm A")} </strong> with booking number <strong> {getTicketId(data._id)}</strong></Typography>
                </Box>
            )
    )
    
}

const CustomDay = (props) => {
    const { dayProps:{day, outsideCurrentMonth,selected,  ...other }, occupiedDate, occupancyData, maxDate, minDate, value, setIsHovered } = props;
    const isError = occupiedDate && (day.isSame(occupiedDate, "day") || day.isAfter(occupiedDate, "day")) && day.isBefore(maxDate) && day.isAfter(minDate)
    const isSelection = value && day.isSameOrBefore(value, "day") && day.isBefore(maxDate, "day") && day.isSameOrAfter(minDate, "day")
    
    const getStyling = () =>{
        if (isError) {
            return { 
                bgcolor : "error.light",
                "&.MuiPickersDay-root": {
                color: "white!important",
                },
                "&:hover": {
                    bgcolor: "error.light",
                    opacity: 0.9,
                },
                "&.MuiPickersDay-root:focus": {
                    backgroundColor: "error.light",
                }
            } 
        } else if (!isError && isSelection) {
            return { 
                bgcolor : "primary.main",
                "&.MuiPickersDay-root": {
                color: "white!important",
                },
                "&.MuiPickersDay-root:focus": {
                    backgroundColor: "primary.main",
                },
                "&:hover": {
                    bgcolor: "primary.main",
                },
            } 
        }
       
    }
    if (occupancyData) {
        return (
                <PickersDay
                    {...other}
                    day={day}
                    selected={selected && !isError}
                    disableRipple={true}
                    outsideCurrentMonth={outsideCurrentMonth}
                    sx={getStyling(day)}
                    onMouseEnter={(e) => {
                        if (isError) {
                            setIsHovered(day)
                        }
                    }}
                    onMouseLeave={(e) => {
                        if (isError) {
                            setIsHovered(undefined)
                        }
                    }}
                />
        )
    }
    return null
}
export default function InlineDateTimePicker({label, value, maxDate, minDate, format, onChange, occupancyData, products}) {

    const [isHovered, setIsHovered] = useState(false)

    let occupiedDate;

    if (occupancyData) {
        occupiedDate = Object.entries(occupancyData)
        .filter(([_, val]) => val !== null)
        .map(([key]) => dayjs(key, "DD-MM-YYYY"))
        .sort((a, b) => a.valueOf() - b.valueOf())[0];  // earliest occupied date
    }
    
    return (
        <Stack direction="column">
            <LocalizationProvider dateAdapter={AdapterDayjs}>
                <Stack direction="row" spacing={2} alignItems="flex-start" sx={{ position: "relative", zIndex: 1, overflow: "visible" }}>
                    <StaticDatePicker
                        value={value}
                        label={label}                    
                        orientation="landscape"
                        maxDate={maxDate}
                        minDate={minDate}
                        format={format}
                        onChange={(newDate)=>{
                            
                            if (occupiedDate && (newDate.isSame(occupiedDate, "day") || newDate.isAfter(occupiedDate, "day"))) {
                                console.log("error")
                                return
                            } else {
                                onChange(newDate)
                            }
                        }}
                        slots={{
                            toolbar: null,
                            actionBar: ()=>null,
                            day: (dayProps) => (
                                <CustomDay
                                    dayProps={dayProps}
                                    occupancyData={occupancyData}
                                    occupiedDate={occupiedDate}
                                    maxDate={maxDate}
                                    minDate={minDate}
                                    value={value}
                                    setIsHovered={setIsHovered}
                                />
                            ),
                        }}
                    />
                    <Box>
                        <DigitalClock
                            value={value}
                            skipDisabled={true}
                            onChange={onChange}
                            minTime={dayjs().hour(7).minute(45)}
                            maxTime={dayjs().hour(22).minute(0)} // 10:00 PM
                            ampm
                            view="hours" // start with hours view
                        />
                    </Box>
                </Stack>
            </LocalizationProvider>
            <Box sx={{minHeight: 80}}>
                {occupancyData && isHovered && (<OccupancyDetails occupancyData={occupancyData} occupiedDate={occupiedDate} isHovered={isHovered} products={products}/>)}
            </Box>
        </Stack>

    );

}
